/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsTestimonialsTabs = {
    init: function ($section) {
      const $sliderElement = $section.find('[data-slider]');

      let slider = $sliderElement.flickity({
        wrapAround: true,
        prevNextButtons: true,
        pageDots: false,
        adaptiveHeight: true,
        cellAlign: 'left',
      });

      let $blocks = $sliderElement.find('[data-index]')
      
      $section.on('click touchstart', '[data-image]', function (e) {        
        let index = $(this).data('index')
        slider.flickity('select', index);        
      });
      setTimeout(function () {
        slider.flickity('resize');
      }, 500); 

      slider.on('select.flickity', function(event, index) {        
        let CurrentSlide = index + 1;        
        $('.testi-tab-image .testi-img:nth-child('+CurrentSlide+')').addClass('current').siblings().removeClass('current');
        $('.testi-tab-image').flickity('select', index);
      });

      function handleResize() {
      if ($(window).width() < 799) {
        // Image Mobile Slider
        $('.testi-tab-image').flickity({
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          wrapAround: true,
          pageDots: false,
          contain: true,
          initialIndex: 2,
          prevNextButtons: false
        });
      }}
      $(window).resize(handleResize);
      handleResize();

    },
    blockSelect: function ($section, blockId) {
      const $slider = $section.find('[data-slider]');
      const slideIndex = $('#shopify-section-' + blockId).data('index');
      $slider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;